import { IccSyslogApi } from '../api/api/IccSyslogApi'
import { IccUserApi } from '../api/api/IccUserApi'
import { User } from '../api/model/User'

export interface ApiState {
  userApi: IccUserApi
  syslogApi: IccSyslogApi
}

const apis = {} as { [key: string]: ApiState }

export async function initApi(url: string, username: string, password: string): Promise<ApiState | undefined> {
  const newApi = {
    syslogApi: new IccSyslogApi(url, { Authorization: `Basic ${btoa(`${username}:${password}`)}` }),
    userApi: new IccUserApi(url, { Authorization: `Basic ${btoa(`${username}:${password}`)}` }),
  }
  const user = await newApi.userApi.current()
  return user && getApi(user, newApi)
}

export function getApi(user: User, newApi?: ApiState): ApiState | undefined {
  if (!user) return undefined
  return apis[user.username] || (apis[user.username] = newApi)
}
